import useDeviceBreakpoints from 'hooks/useDeviceBreakpoints';

import { StepsProvider } from './hooks';
import {
  UserFirstAccessDesktopLayout,
  UserFirstAccessMobileLayout,
} from './layout/index';

export function UserFirstAccessPage() {
  const { isMobileOrTablet } = useDeviceBreakpoints();

  return (
    <StepsProvider>
      {isMobileOrTablet ? (
        <UserFirstAccessMobileLayout />
      ) : (
        <UserFirstAccessDesktopLayout />
      )}
    </StepsProvider>
  );
}
